import React, { useEffect, useState } from 'react';

import { useNavigationState, useNavigationUpdate } from '../../context';
import Screen from '../Screen';

import StaticStackRenderer from './StaticStack';
import SlidingStackRenderer from './SlindingStack';

export type ScreensType = {
    [key: string]: {
        component: React.ComponentType<any>;
        params?: Record<string, any>;
    };
};

function StackRenderer({ children, animated }: { children: React.ReactNode; animated?: boolean }) {
    const { stack } = useNavigationState();
    const { push } = useNavigationUpdate();

    const [screens, setScreens] = useState<ScreensType>({});

    useEffect(() => {
        const reducedScreens = React.Children.toArray(children).reduce<ScreensType>((acc, child) => {
            if (React.isValidElement(child) && child.type === Screen) {
                acc[child.props.name] = {
                    component: child.props.component,
                    params: child.props.params,
                };
            }
            return acc;
        }, {});

        setScreens(reducedScreens);
    }, [children]);

    useEffect(() => {
        if (stack.length === 0 && Object.keys(screens).length > 0) {
            const firstScreenName = Object.keys(screens)[0];
            push(firstScreenName, screens[firstScreenName].params);
        }
    }, [stack, push, screens]);

    if (Object.keys(screens).length === 0) {
        return null;
    }

    if (animated) {
        return <SlidingStackRenderer screens={screens} />;
    }

    return <StaticStackRenderer screens={screens} />;
}

export default StackRenderer;
